/*
 * The thank-you and order page (the Prints mockup's .ty, .ty-top, .ty-mark,
 * .card, .ty-order, .offer, .benefits, .od, .steps, .track-box and .od-side,
 * with their phone rules), in theme tokens. In the telify layer.
 */
@layer telify {
  .ty {
    max-width: 860px;
    margin: 0 auto;
    display: grid;
    gap: 28px;
  }

  .tyTop {
    text-align: center;
    display: grid;
    justify-items: center;
    gap: 10px;
  }

  .tyMark {
    width: 58px;
    height: 58px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    border: 1px solid rgba(var(--accent-rgb), 0.45);
    color: var(--accent);
    background: rgba(var(--accent-rgb), 0.06);
  }

  .tyMark svg {
    width: 26px;
    height: 26px;
  }

  .tyTop h1 {
    margin-top: 6px;
    font-family: var(--font-display);
    font-weight: 500;
    font-size: clamp(44px, 5vw, 68px);
    line-height: 1;
  }

  .tyTop p {
    color: var(--text-secondary);
    font-size: 16px;
  }

  .tyTop .meta {
    font-size: 14px;
    color: var(--text-tertiary);
    font-variant-numeric: tabular-nums;
  }

  .card {
    border: var(--line);
    background: var(--bg-card);
    padding: 26px 28px;
  }

  .tyOrder {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 18px 30px;
    align-items: start;
  }

  .tyOrder dl {
    display: grid;
    gap: 4px 0;
    font-size: 14.5px;
    min-width: 210px;
  }

  .tyOrder dt {
    color: var(--text-tertiary);
    font-size: 13px;
    margin-top: 8px;
  }

  .tyOrder dt:first-child {
    margin-top: 0;
  }

  .center {
    text-align: center;
  }

  .offer {
    border: 1px solid rgba(var(--accent-rgb), 0.32);
    background:
      radial-gradient(ellipse 70% 90% at 10% 0%, rgba(var(--accent-rgb), 0.16), transparent 70%),
      var(--bg-card);
    padding: 34px 36px;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
    gap: 28px 44px;
  }

  .offer h2,
  .updates h2 {
    font-family: var(--font-display);
    font-weight: 500;
    font-size: clamp(28px, 3.2vw, 42px);
    line-height: 1.05;
  }

  .lead {
    margin: 12px 0 22px;
    color: var(--text-secondary);
    font-size: 16px;
  }

  .acts {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 14px 22px;
  }

  .textlink {
    font-size: 15px;
    color: var(--accent);
    background: none;
    border: 0;
    border-bottom: 1px solid rgba(var(--accent-rgb), 0.4);
    padding: 0 0 3px;
    cursor: pointer;
  }

  .problem {
    margin-top: 14px;
    font-size: 14.5px;
    color: var(--danger);
  }

  .benefits {
    list-style: none;
    display: grid;
    gap: 14px;
    align-content: center;
  }

  .benefits li {
    display: grid;
    grid-template-columns: 34px minmax(0, 1fr);
    gap: 12px;
    align-items: start;
    font-size: 15.5px;
    line-height: 1.45;
  }

  .benefits li > span:first-child {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    background: rgba(var(--accent-rgb), 0.08);
    border: 1px solid rgba(var(--accent-rgb), 0.22);
    color: var(--accent);
  }

  .benefits b {
    display: block;
    font-weight: 500;
  }

  .benefits small {
    display: block;
    font-size: 13.5px;
    color: var(--text-tertiary);
  }

  .updates {
    display: grid;
    gap: 12px;
    justify-items: start;
  }

  .head {
    margin-bottom: 30px;
  }

  .head h1 {
    font-family: var(--font-display);
    font-weight: 500;
    font-size: clamp(42px, 4.6vw, 64px);
    line-height: 1;
  }

  .head .note {
    margin-top: 10px;
  }

  .note {
    font-size: 13.5px;
    color: var(--text-tertiary);
  }

  .od {
    display: grid;
    grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr);
    gap: 40px;
    align-items: start;
  }

  .part + .part {
    margin-top: 28px;
  }

  .partTitle {
    margin-bottom: 14px;
    font-size: 15px;
    font-weight: 600;
  }

  .ended {
    font-size: 15px;
    color: var(--text-secondary);
  }

  .steps {
    list-style: none;
    margin: 0 0 6px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .steps li {
    position: relative;
    padding-top: 34px;
    font-size: 15px;
    color: var(--text-tertiary);
  }

  .steps li::before {
    content: '';
    position: absolute;
    top: 10px;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--border-soft);
  }

  .steps li i {
    position: absolute;
    top: 3px;
    left: 0;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--bg-page);
    border: 2px solid var(--field-line);
  }

  .steps li b {
    display: block;
    font-weight: 500;
  }

  .steps li small {
    display: block;
    font-size: 13px;
    color: var(--text-tertiary);
    font-variant-numeric: tabular-nums;
  }

  .steps li.done,
  .steps li.now {
    color: var(--text-primary);
  }

  .steps li.done::before {
    background: var(--accent);
  }

  .steps li.now::before {
    background: linear-gradient(90deg, var(--accent) 50%, var(--border-soft) 50%);
  }

  .steps li.done i {
    background: var(--accent);
    border-color: var(--accent);
  }

  .steps li.now i {
    border-color: var(--accent);
    box-shadow: 0 0 0 5px rgba(var(--accent-rgb), 0.14);
  }

  .track {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-top: 24px;
    padding: 16px 18px;
    border-radius: 6px;
    border: var(--line);
    font-size: 14.5px;
  }

  .sub {
    color: var(--text-tertiary);
    font-size: 13.5px;
    font-variant-numeric: tabular-nums;
  }

  .sm {
    height: 40px;
    padding: 0 20px;
    font-size: 14px;
  }

  .spaced {
    margin-top: 26px;
  }

  .items {
    display: grid;
    gap: 14px;
  }

  .item {
    display: grid;
    grid-template-columns: 56px minmax(0, 1fr) auto;
    gap: 14px;
    align-items: center;
    font-variant-numeric: tabular-nums;
  }

  .thumb {
    position: relative;
    width: 56px;
    height: 68px;
    background: var(--tint);
  }

  .q {
    position: absolute;
    top: -7px;
    right: -7px;
    min-width: 20px;
    height: 20px;
    border-radius: 999px;
    background: var(--accent);
    color: var(--text-on-accent);
    font-size: 11.5px;
    line-height: 20px;
    text-align: center;
  }

  .itemName {
    font-family: var(--font-display);
    font-size: 18px;
    line-height: 1.15;
  }

  .totals {
    display: grid;
    gap: 8px;
    margin-top: 18px;
    padding-top: 16px;
    border-top: var(--line);
  }

  .line {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    font-size: 15px;
    font-variant-numeric: tabular-nums;
  }

  .big {
    font-size: 18px;
  }

  .shipTo {
    display: grid;
    gap: 4px;
    margin-top: 18px;
    font-size: 14.5px;
  }

  .side {
    display: grid;
    gap: 16px;
  }

  .side .offer {
    grid-template-columns: 1fr;
    padding: 26px 24px;
  }

  @media (max-width: 860px) {
    .offer {
      grid-template-columns: 1fr;
      padding: 26px 20px;
    }

    .card {
      padding: 22px 18px;
    }

    .tyOrder,
    .od {
      grid-template-columns: 1fr;
    }

    .steps {
      grid-template-columns: 1fr;
      gap: 0;
    }

    .steps li {
      padding: 0 0 22px 34px;
    }

    .steps li::before {
      top: 18px;
      bottom: -2px;
      left: 7px;
      right: auto;
      width: 2px;
      height: auto;
    }

    .steps li:last-child::before {
      display: none;
    }

    .steps li.now::before {
      background: linear-gradient(180deg, var(--accent) 50%, var(--border-soft) 50%);
    }
  }
}
